module.exports = __webpack_public_path__ + "img/display-solid.39cfe640.svg";